import React from 'react';
import { Link } from 'react-router-dom';
// import '../../Sidebar.css';

function Principal() {

	return (
    <div className="content">
			<h1>Bem vindo</h1>
			<p>
				Aplicação de Transposrte por Aplicativo, você pode utilizar o menu superior para entrar ou
				<br />clicando diretamente aqui <Link to={`/login`}>login</Link>.
			</p>
			<p>
				Para efetuar o <Link to={`/cadastro`}>cadastro como empresa de transporte por aplicativo clique aqui</Link>.
			</p>
			<p>
					É necessário estar logado no sistema, caso você ainda não esteja logado
					será redirecionado para a página de login.
			</p>
		</div>
	);
	}
  
export default Principal;